export const DEVELOPER_FOOTER = Object.freeze({ title: 'Documentation', label: 'Developer Resources', href: '/docs', event: 'developer_resources_clicked', location: 'footer' });
